const preloadImages = (src, onLoad, onError) => new Promise((resolve) => {
  const img = new Image();
  img.onload = () => {
    if (onLoad) {
      onLoad(src);
    }
    resolve(img);
  };
  img.onerror = () => {
    if (onError) {
      onError(src);
    }
    resolve(null);
  };
  img.onabort = () => {
    if (onError) {
      onError(src);
    }
    resolve(null);
  };
  img.src = src;
});

export default preloadImages;
